import { ObservationDetails } from '../../objects/observationDetails';
import { CacheableEndpoint, RequestMethod } from '../../public_api';
import { ApiResponse } from '../apiResponse.interface';
import { MockObservationMaker } from './mockObservationMaker';

export class GetObservationDetails extends CacheableEndpoint<
  ObservationDetails,
  GetObservationParams
> {
  protected getCacheKey(params: GetObservationParams): string {
    return params.id;
  }

  protected callLive(params: GetObservationParams): Promise<ObservationDetails> {
    const callResponsePromise = this.apiCaller.doCall(
      ['observations', params.id],
      RequestMethod.GET,
    );

    return this.buildObjectFromResponse(ObservationDetails, callResponsePromise);
  }
  /* eslint-disable @typescript-eslint/no-unused-vars */
  protected callMock(params: GetObservationParams): Promise<ObservationDetails> {
    const callResponsePromise = ApiResponse.createMockResponseObject(
      MockObservationMaker.doDetailsReplacements(),
    );
    return this.buildObjectFromResponse(ObservationDetails, callResponsePromise);
  }
}
export interface GetObservationParams {
  id: string;
}
